/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { formatDependencies } from './dependenciesFormat.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createHex } from '../../factoriesAny.js';
export var hexDependencies = {
  formatDependencies,
  typedDependencies,
  createHex
};